import { EnumBase } from 'hay-core-react';
class ConfiguracaoConfirmacaoCadastroEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.configuracao.confirmacaocadastro.nao',
                'main.configuracao.confirmacaocadastro.email',
                'main.configuracao.confirmacaocadastro.sms',
                'main.configuracao.confirmacaocadastro.emailousms',
            ],
            'main.configuracao.confirmacaocadastro.nao'
        );
    }
}

const instance = new ConfiguracaoConfirmacaoCadastroEnum();
export default instance;
